import { CollectionTemplate } from '../models/CollectionTemplate';

/** Values stored on `CollectionTemplate.automations`. */
export enum TemplateAutomation {
  TIME = 'TIME',
  CFORM = 'CFORM',
}

/** Pushed to `CollectionTemplate.automations` when the TIME toggle is on. */
export const TEMPLATE_AUTOMATION_TIME = TemplateAutomation.TIME;

/** Pushed to `CollectionTemplate.automations` when the CFORM toggle is on. */
export const TEMPLATE_AUTOMATION_C_FORM = TemplateAutomation.CFORM;

export function ensureTemplateAutomation(template: CollectionTemplate): void {
  if (!Array.isArray(template.automations)) {
    template.automations = [];
  }
}

export function templateHasAutomation(template: CollectionTemplate, key: string): boolean {
  return Array.isArray(template.automations) && template.automations.includes(key);
}

export function setTemplateAutomationEnabled(
  template: CollectionTemplate,
  key: string,
  enabled: boolean,
): void {
  ensureTemplateAutomation(template);
  const i = template.automations.indexOf(key);
  if (enabled && i < 0) {
    template.automations.push(key);
  } else if (!enabled && i >= 0) {
    template.automations.splice(i, 1);
  }
}
